const languageTypes = {
  LOADING: "loading",
  LANGUAGE: "master/getLocalizationLanguageByCode",
};

export default languageTypes;
